import { UAParser } from 'ua-parser-js';
const _userAgent = navigator.userAgent.toLowerCase();

/**
 * detect language
 */
export function detectLocaleByHtml ({ defaultLang = 'ja' } = {}) {
  const htmlLang = document.documentElement.lang || '';
  const metaLanguage = document.querySelector('meta[http-equiv="Content-Language"]')?.content || '';
  const lang = htmlLang || metaLanguage || '';
  const localeMap = {
    ja: 'ja',
    'ja-JP': 'ja',
    en: 'en',
    'en-US': 'en',
    'en-GB': 'en',
    zh: 'zh',
    'zh-CN': 'zh',
    'zh-TW': 'zh',
    ko: 'ko',
    'ko-KR': 'ko',
    fr: 'fr',
    'fr-FR': 'fr'
  };

  const getLocaleName = langCode => {
    if (!langCode) return '';

    if (localeMap[langCode]) {
      return localeMap[langCode];
    }

    const baseCode = langCode.split('-')[0];
    if (localeMap[baseCode]) {
      return `${localeMap[baseCode]} (${langCode})`;
    }

    return langCode;
  };

  return {
    htmlLang,
    metaLanguage,
    locale: getLocaleName(lang) || defaultLang
  };
}

/**
 * setCookie
 */
export function setCookie (options) {
  const { name = '', expire_hour = 24 * 7, value = 1, same_site = 'lax', path = '/' } = options;

  const expire = new Date();
  const samesite = same_site === 'none' ? 'none; Secure' : same_site;

  expire.setTime(expire.getTime() + 1000 * 3600 * expire_hour);
  document.cookie = `${name}=${value}; expires=${expire.toUTCString()}; SameSite=${samesite}; path=${path};`;
}

/**
 * getCookie
 */
export function getCookie (name) {
  let result = null;

  const cookieName = name + '=';
  const allcookies = document.cookie;

  const position = allcookies.indexOf(cookieName);
  if (position != -1) {
    const startIndex = position + cookieName.length;

    let endIndex = allcookies.indexOf(';', startIndex);
    if (endIndex == -1) {
      endIndex = allcookies.length;
    }

    result = decodeURIComponent(allcookies.substring(startIndex, endIndex));
  }

  return result;
}

/**
 * deleteCookie
 */
export function deleteCookie (name) {
  const cookiName = encodeURIComponent(name);
  document.cookie = `${cookiName}=; max-age=0`;
}

/**
 * getUrlParameters
 */
export function getUrlParameters () {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = {};

  for (const [key, value] of searchParams.entries()) {
    paramsObject[key] = value;
  }

  return paramsObject;
}

/**
 * getParsedUA
 */
export function getUserAgent () {
  return new UAParser(_userAgent).getResult();
}

export async function nextTick (callback) {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      resolve();
      if (callback) callback();
    });
  });
}
